import React from 'react';
import { NavLink } from 'react-router-dom';
var GroupListItem = function (_a) {
    var children = _a.children, tag = _a.tag, href = _a.href, className = _a.className, onClick = _a.onClick, active = _a.active;
    if (tag === 'a' && href) {
        return (React.createElement(NavLink, { to: href, className: 'group-list-item ' +
                (href ? 'group-list-item-link  ' : '') +
                (active ? 'group-list-item-active ' : '') +
                (className ? className : '') }, children));
    }
    else {
        return (React.createElement("li", { className: 'group-list-item ' + (className ? className : ''), onClick: onClick }, children));
    }
};
export { GroupListItem };
//# sourceMappingURL=GroupListItem.js.map